/**
 * Nightcap — FAQ Accordion Web Component
 * Accessible accordion: aria-expanded, keyboard navigation (arrows, Home, End).
 * Single-open mode: opening one closes others.
 */
class NcFaqAccordion extends HTMLElement {
  connectedCallback() {
    this.buttons = Array.from(this.querySelectorAll('.nc-faq__question'));
    var self = this;

    this.buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        self.toggle(button);
      });
      button.addEventListener('keydown', function (e) {
        self.handleKeydown(e, button);
      });
    });

    /* Initialize all answers as hidden */
    this.buttons.forEach(function (button) {
      var answerId = button.getAttribute('aria-controls');
      var answer = document.getElementById(answerId);
      if (answer) {
        answer.setAttribute('aria-hidden', 'true');
      }
    });
  }

  toggle(button) {
    var expanded = button.getAttribute('aria-expanded') === 'true';
    var answerId = button.getAttribute('aria-controls');
    var answer = document.getElementById(answerId);
    var self = this;

    /* Close all others (single-open mode) */
    this.buttons.forEach(function (btn) {
      if (btn !== button) {
        btn.setAttribute('aria-expanded', 'false');
        var otherAnswerId = btn.getAttribute('aria-controls');
        var otherAnswer = document.getElementById(otherAnswerId);
        if (otherAnswer) {
          otherAnswer.setAttribute('aria-hidden', 'true');
        }
      }
    });

    /* Toggle the clicked one */
    button.setAttribute('aria-expanded', String(!expanded));
    if (answer) {
      answer.setAttribute('aria-hidden', String(expanded));
    }
  }

  handleKeydown(e, button) {
    var index = this.buttons.indexOf(button);
    var target;

    switch (e.key) {
      case 'ArrowDown':
        e.preventDefault();
        target = this.buttons[(index + 1) % this.buttons.length];
        break;
      case 'ArrowUp':
        e.preventDefault();
        target = this.buttons[(index - 1 + this.buttons.length) % this.buttons.length];
        break;
      case 'Home':
        e.preventDefault();
        target = this.buttons[0];
        break;
      case 'End':
        e.preventDefault();
        target = this.buttons[this.buttons.length - 1];
        break;
    }

    if (target) {
      target.focus();
    }
  }
}

customElements.define('nc-faq-accordion', NcFaqAccordion);

/* Theme editor compatibility */
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function () {
    /* Re-init happens automatically via connectedCallback for web components */
  });
}
